<div class="margin-10 fixed-width">
  <p class="margin-10 column">Integration Type</p>
  <dropdown [currentValue]="REDOX"
    [options]="integrationOptions"
    (change)="changeIntegrationType($event)">
  </dropdown>
</div>

@if (redoxIntegrationType()) {
  <span>
    <app-redox-setup [hospital]="hospital"></app-redox-setup>
  </span>
}

@if (partnerIntegrationType()) {
  <span>
    <app-partner-setup [hospital]="hospital"></app-partner-setup>
  </span>
}
